import MapView from 'react-native-web-maps';
import {View} from 'react-native';

export const Marker = MapView.Marker || View;
export const Circle = MapView.Circle || View;
export const Callout = MapView.Callout || View;
export const MapViewCluster = MapView;
export const PROVIDER_GOOGLE = 'google';

export default MapView;
